@if (mainFilename$ | async; as mainFilename) {
  <vwg-angebot
    *axLazyElement="'vwg-angebot/' + mainFilename"
    [dispatcher]="globalEventDispatcher"></vwg-angebot>
}
